"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.InternalSettings = void 0;
const react_1 = __importStar(require("react"));
const react_intl_1 = require("react-intl");
const lodash_1 = require("lodash");
const Typography_1 = __importDefault(require("@material-ui/core/Typography"));
const styles_1 = require("@material-ui/core/styles");
const EditOutlined_1 = __importDefault(require("@material-ui/icons/EditOutlined"));
const Save_1 = __importDefault(require("@material-ui/icons/Save"));
const Undo_1 = __importDefault(require("@material-ui/icons/Undo"));
const detail_toolbar_button_2_1 = require("../../composite/detail/detail-toolbar-button-2");
const form_1 = require("../../composite/form/form");
const common_params_1 = require("../../utils/common-params");
const event_callback_hook_1 = require("../../utils/event-callback-hook");
const internal_settings_context_1 = require("./internal-settings-context");
const internal_settings_fields_1 = require("./internal-settings-fields");
const internal_settings_provider_1 = require("./internal-settings-provider");
const internal_settings_types_1 = require("./internal-settings-types");
const useStyles = (0, styles_1.makeStyles)({
    page: {
        backgroundColor: '#f1f3f4',
        height: '100%',
        overflowY: 'auto',
    },
    titleWrapper: {
        textAlign: 'left',
        borderBottom: '1px solid #cdcdcd',
    },
    title: {
        margin: '10px 0',
        fontSize: 25,
        fontWeight: 500,
    },
    header: {
        marginBottom: 6,
        boxShadow: '0px 0px 10px #ccc',
        padding: '12px 40px',
        backgroundColor: '#fafafa',
        width: '100%',
        position: 'sticky',
        top: 0,
        zIndex: 99,
    },
    toolbar: {
        display: 'flex',
        justifyContent: 'start',
        flex: '0 0 auto',
    },
    container: {
        width: '100%',
    },
});
function InternalSettings({ config, loadAutocompleteLabels = true, }) {
    const classes = useStyles();
    const { loading, saveInternalSettings, settingGroups } = (0, react_1.useContext)(internal_settings_context_1.InternalSettingsContext);
    const formRef = (0, react_1.useRef)(null);
    const [editing, setEditing] = (0, react_1.useState)(false);
    const handleStartEditing = (0, event_callback_hook_1.useEventCallback)(() => {
        setEditing(true);
    });
    const handleCancelEditing = (0, event_callback_hook_1.useEventCallback)(() => {
        var _a;
        setEditing(false);
        (_a = formRef.current) === null || _a === void 0 ? void 0 : _a.setFieldValue('settingGroups', settingGroups);
    });
    const handleSubmit = (0, event_callback_hook_1.useEventCallback)(async () => {
        if (formRef.current != undefined) {
            await saveInternalSettings(formRef.current.getFieldValues().settingGroups);
            setEditing(false);
        }
    });
    (0, react_1.useEffect)(() => {
        var _a;
        const loadLabels = async () => {
            var _a;
            const settings = await loadAutocompleteSettings(settingGroups, config);
            (_a = formRef === null || formRef === void 0 ? void 0 : formRef.current) === null || _a === void 0 ? void 0 : _a.setFieldValue('settingGroups', settings);
        };
        if (loadAutocompleteLabels) {
            loadLabels();
        }
        else {
            (_a = formRef === null || formRef === void 0 ? void 0 : formRef.current) === null || _a === void 0 ? void 0 : _a.setFieldValue('settingGroups', settingGroups);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [settingGroups]);
    const hasEditableSetting = (0, lodash_1.flatten)(settingGroups.map((group) => group.settings)).some((setting) => setting === null || setting === void 0 ? void 0 : setting.canEdit);
    return (react_1.default.createElement(internal_settings_provider_1.InternalSettingsConfigProvider, { config: config },
        react_1.default.createElement("div", { className: classes.page },
            react_1.default.createElement(form_1.Form, { initialValues: {}, editing: !loading && editing, onSubmit: handleSubmit, ref: formRef },
                react_1.default.createElement("div", { className: classes.container },
                    react_1.default.createElement("div", { className: classes.header },
                        react_1.default.createElement(Typography_1.default, { variant: "h1", className: classes.title },
                            react_1.default.createElement(react_intl_1.FormattedMessage, { id: "EAS__INTERNAL_SETTTINGS__TITLE", defaultMessage: "Nastaven\u00ED aplikace" })),
                        react_1.default.createElement(Buttons, { editing: editing, handleStartEditing: handleStartEditing, handleCancelEditing: handleCancelEditing, handleSave: handleSubmit, loading: loading, disabledEditBtn: !hasEditableSetting })),
                    react_1.default.createElement(internal_settings_fields_1.SettingsFields, null))))));
}
exports.InternalSettings = InternalSettings;
const Buttons = ({ loading, editing, handleCancelEditing, handleStartEditing, disabledEditBtn = false, handleSave, }) => {
    const classes = useStyles();
    return (react_1.default.createElement("div", { className: classes.toolbar },
        !editing && (react_1.default.createElement(detail_toolbar_button_2_1.DetailToolbarButton, { disabled: loading || disabledEditBtn, onClick: handleStartEditing, label: react_1.default.createElement(react_intl_1.FormattedMessage, { id: "EAS__INTERNAL_SETTINGS__BTN_EDIT", defaultMessage: "Upravit" }), startIcon: react_1.default.createElement(EditOutlined_1.default, null) })),
        editing && (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(detail_toolbar_button_2_1.DetailToolbarButton, { disabled: loading, startIcon: react_1.default.createElement(Save_1.default, null), label: react_1.default.createElement(react_intl_1.FormattedMessage, { id: "EAS__INTERNAL_SETTINGS__BTN_SAVE", defaultMessage: "Ulo\u017Eit" }), onClick: handleSave }),
            react_1.default.createElement(detail_toolbar_button_2_1.DetailToolbarButton, { disabled: loading, onClick: handleCancelEditing, label: react_1.default.createElement(react_intl_1.FormattedMessage, { id: "EAS__INTERNAL_SETTINGS__BTN_CANCEL", defaultMessage: "Zru\u0161it" }), startIcon: react_1.default.createElement(Undo_1.default, null) })))));
};
const loadAutocompleteSettings = async (settingGroups = [], config = []) => {
    var _a, _b, _c;
    const groups = [];
    for (const group of settingGroups) {
        let settings = (_a = group === null || group === void 0 ? void 0 : group.settings) !== null && _a !== void 0 ? _a : [];
        const autocompleteSettings = (_c = (_b = group === null || group === void 0 ? void 0 : group.settings) === null || _b === void 0 ? void 0 : _b.filter((setting) => setting.inputType.name === internal_settings_types_1.SimpleEasSettingInputType.AUTOCOMPLETE)) !== null && _c !== void 0 ? _c : [];
        const autocompleteWithConfig = autocompleteSettings.map((setting) => {
            var _a;
            return ({
                url: (_a = config === null || config === void 0 ? void 0 : config.find((c) => c.code === setting.code)) === null || _a === void 0 ? void 0 : _a.autocompleteUrl,
                ...setting,
            });
        });
        await Promise.all(autocompleteWithConfig.map(async (autocomplete) => {
            var _a;
            if (autocomplete.url && ((_a = autocomplete.value) === null || _a === void 0 ? void 0 : _a.id)) {
                const response = await fetch(autocomplete === null || autocomplete === void 0 ? void 0 : autocomplete.url, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify((0, common_params_1.eqFilterParams)({
                        field: 'id',
                        value: autocomplete.value.id,
                    })),
                });
                const json = await response.json();
                settings = [
                    ...settings.filter((setting) => setting.code !== autocomplete.code),
                    { ...autocomplete, value: json.items[0] },
                ];
            }
        }));
        groups.push({
            ...group,
            settings: settings,
        });
    }
    return groups;
};
//# sourceMappingURL=internal-settings.js.map